import React, { useRef, useState } from 'react';
import { useEditCompalinWebMutation, useGetCompalinWebStatusQuery } from './CompalinWebSlice';
import { useParams } from 'react-router-dom';

const CompalinWebAction = () => {
    const [data, setData] = useState({ c_status: '', c_id: '' });
    const ref = useRef(null);
    const { id } = useParams();

    const {
        data: CompalinWebStatus,
        isStatusListError,
        isStatusListLoading,
        isChangeStatusLoading
    } = useGetCompalinWebStatusQuery("getCompalinWebStatus");

    const [editCompalinWeb] = useEditCompalinWebMutation()
    console.log("editCompalinWeb", editCompalinWeb);


    const handleChangeComplainStatus = (e) => {
        const { name, value } = e.target
        setData({ ...data, [name]: value })
    }

    const handleClickEdit = async (e) => {
        try {
            await editCompalinWeb({ id: id, body: { c_status: data?.c_status } }).unwrap();
            ref.current.click()
        }
        catch (e) {
            console.error("Error in community edit", e)
        }
    }
    return (
        <div>
            <div className="offcanvas offcanvas-end" tabindex="-1" id="compalinWebAction" aria-labelledby="offcanvasLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasLabel">Action </h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
                        ref={ref}
                    >

                    </button>
                </div>
                <div className="offcanvas-body d-flex flex-column justify-content-start mb-5">
                    <select
                        className="form-select mb-5"
                        aria-label="complain status"
                        name="c_status"
                        value={data.c_status}
                        onChange={handleChangeComplainStatus}
                    >
                        <option selected>--</option>
                        {!isStatusListLoading && !isStatusListError && CompalinWebStatus?.map(item => {
                            return <option value={item}>{item}</option>
                        })
                        }
                    </select>
                    <button className="btn btn-ff9b44 btn-round"
                        onClick={() => (handleClickEdit(ref, { id: id, c_status: data.c_status }))}
                    // disabled={isChangeStatusLoading}
                    >Submit</button>
                </div>
            </div>
        </div>
    );
}

export default CompalinWebAction;
